














import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import _ from 'lodash'
import HttpRequestServiceWithToken from '@/services/HttpRequestServiceWithToken'
import { IUser } from '@/store/modules/views/user/states'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'

@Component
export default class DeleteStaffDialog extends VueExtendedBaseComponent {
  @Prop() private open!: boolean
  @Prop() private user!: IUser
  @Prop() private callback!: () => Promise<void>

  private loading = false

  get openDialog() {
    return this.open
  }

  set openDialog(value: boolean) {
    this.$emit('update:open', false)
  }

  get deleteHeadDialogOption() {
    return {
      justify: 'start',
      button: {
        justify: 'center',
        cancelButton: {
          title: 'ปิด',
          action: this.closeDialog,
          height: '30',
        },
        submitButton: {
          title: 'ลบ',
          action: this.deleteUserAction,
          loading: this.loading,
          height: '30',
        },
      },
    }
  }

  private async deleteUserAction() {
    this.loading = true
    try {
      await HttpRequestServiceWithToken.putByLevel(
        `${process.env.VUE_APP_API_URL}/v1`,
          `user/${this.user._id}/role/11175c71fbe64ad49759e94b7f5b3a07`,
          {centerId: ''},
        async () => {
          this.updateSnackbar({txt: 'ลบผู้ดูแลประจำศูนย์บริการสำเร็จ.', type: 'success'})
          await this.callback()
          this.loading = false
          this.closeDialog()
        },
      )
    } catch (e) {
      this.loading = false
    }
  }

  private closeDialog() {
    this.$emit('update:open', false)
  }
}
